import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/times-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-31bacfd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "close-button"
}, null, -1))

import { Contact } from '../struct'
import { computed } from 'vue'


export default {
  __name: 'ContactPicker',
  props: { modelValue: {} },
  emits: ['update:modelValue', 'close', 'destroy'],
  setup(__props, { emit: emits }) {





const choices = computed(() => Object.values(Contact))

function contactToImg (contact) {
  switch (contact) {
    case Contact.Air:
      return require('../assets/glyphs/Air.svg')
    case Contact.Contact:
      return require('../assets/glyphs/Contact.svg')
    case Contact.Object:
      return require('../assets/glyphs/Object.svg')
    default:
      return false
  }
}

function emitChoice (choice) {
  emits('update:modelValue', choice)
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("div", {
    class: "contact-picker",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => (emits('close')), ["stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(choices), (choice) => {
      return (_openBlock(), _createElementBlock("button", {
        key: choice,
        onClick: () => emitChoice(choice),
        class: "menu-item"
      }, [
        (contactToImg(choice))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: contactToImg(choice)
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    }), 128)),
    _hoisted_3,
    _createElementVNode("button", {
      class: "delete-button",
      onClick: _cache[0] || (_cache[0] = $event => (emits('destroy')))
    }, [
      _createVNode(_component_unicon, { name: "trash-alt" })
    ])
  ]))
}
}

}